module.exports = __webpack_public_path__ + "img/april-for-autism.802a6191.png";